<template>
  <div class="save-bar">
    <bottomBar>
      <qvoButton v-if="isShowingChangeSummary" text @click="hideChangeSummary"
        >Cancel</qvoButton
      >
      <qvoButton v-if="isTemplate" to="/clients/templates" text
        >Cancel</qvoButton
      >
      {{ /* isFormValid will handle both templates and non-templates.  The logic for this is in client.vue */ }}
      <qvoButton
        @click="commitAction"
        :disabled="!hasUpdatedConfigValues[id] || !isFormValid"
        >{{ saveLabel }}</qvoButton
      >
    </bottomBar>
    <confirmationModal
      :value="confirmationModalOpen"
      v-bind="$attrs"
      v-on="$listeners"
      title="Are you sure you want to commit?"
      @closeModal="closeConfirmationModal"
    >
      <template #buttons>
        <qvoButton text @click="closeConfirmationModal">Cancel</qvoButton>
        <qvoButton @click="saveConfig">Yes, Commit</qvoButton>
      </template>
    </confirmationModal>
  </div>
</template>

<script>
/**
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";

import changeCount from "@/util/changeCount";

import qvoButton from "@/qux-common/qux22/components/molecules/button";

import bottomBar from "@/components/bottom-bar";
import confirmationModal from "@/components/confirmation-modal";

export default {
  name: "SaveBar",
  components: { qvoButton, bottomBar, confirmationModal },
  data() {
    return {
      confirmationModalOpen: false,
    };
  },
  props: {
    id: {
      type: String,
    },
    title: {
      type: String,
    },
    details: {
      type: String,
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
    isFormValid: {
      type: Boolean,
      default: false,
    },
    isShowingChangeSummary: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    changeCount() {
      return changeCount(this.updatedConfigValues[this.id]);
    },
    saveLabel() {
      if (this.isShowingChangeSummary) return "Confirm Commit";
      if (!this.isTemplate) return "Commit Changes";
      return this.id === "createTemplate" ? "Create" : "Save";
    },
    ...mapGetters({
      hasUpdatedConfigValues: "hasUpdatedConfigValues",
      updatedConfigValues: "getUpdatedConfigValues",
      config: "getConfig",
      nextEnvironment: "getNextEnvironment",
    }),
  },
  methods: {
    closeConfirmationModal() {
      this.confirmationModalOpen = false;
    },
    commitAction() {
      if (this.isTemplate) {
        this.saveConfig();
        return;
      }
      this.isShowingChangeSummary
        ? this.confirmSave()
        : this.showChangeSummary();
    },
    showChangeSummary() {
      this.$emit("showChangeSummary");
    },
    hideChangeSummary() {
      this.$emit("hideChangeSummary");
    },
    confirmSave() {
      if (this.nextEnvironment) {
        this.confirmationModalOpen = true;
      } else {
        this.saveConfig();
      }
    },
    saveConfig() {
      this.closeConfirmationModal();
      const args = this.isTemplate
        ? {
            IsTemplate: true,
            ClientId:
              (this.config[this.id] &&
                this.config[this.id].Info &&
                this.config[this.id].Info.ClientId) ||
              this.updatedConfigValues[this.id].Info.ClientId,
            ClientInfoRuleId:
              this.id === "createTemplate" ? "createTemplate" : this.id,
          }
        : {
            ClientId: this.config[this.id].Info.ClientId,
            ClientInfoRuleId: this.id,
            ChangeTitle: this.title,
            ChangeDetails: this.details,
          };
      this.$store.dispatch("saveConfig", args);
      this.hideChangeSummary();
    },
  },
};
</script>

<style lang="scss" scoped>
.save-bar {
  width: 100%;
}
</style>